import { useState, useEffect } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'

function CreateNotification({
  selectedNotification,
  fetchNotifications,
  setShowNotification,
  setSelectedNotification,
}: any) {
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [notificationData, setNotificationData] = useState({
    title: '',
    message: '',
  })

  async function changeRole() {
    const data: any = {
      title: notificationData.title,
      message: notificationData.message,
    }
    if (notificationData.title.length < 4) {
      notify('warn', 'Title must be at least 4 characters')
      return
    }
    if (notificationData.message.length < 4) {
      notify('warn', 'Message must be at least 4 characters')
      return
    }
    setCancelLoading(true)
    let url = 'notifications'
    if (selectedNotification) {
      url = `notifications/${selectedNotification.id}`
    }

    post(url, data, null)
      .then((result: any) => {
        if (result.status === 201 || result.status === 200) {
          if (selectedNotification) {
            notify('success', 'Notification Updated')
          } else {
            notify('success', 'Notification Created')
          }
          setShowNotification(false)
          setSelectedNotification(null)
          fetchNotifications()
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }

  useEffect(() => {
    if (selectedNotification) {
      setNotificationData({
        title: selectedNotification.title,
        message: selectedNotification.message,
      })
    }
  }, [selectedNotification])

  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>
          {selectedNotification ? 'Update Notification' : 'Create Notification'}
        </h1>
        <p>
          Note: this will {selectedNotification ? 'Update' : 'Create'} a
          notification on the users end
        </p>

        <input
          type='text'
          placeholder='Title'
          value={notificationData.title}
          onChange={(e) =>
            setNotificationData({
              ...notificationData,
              title: e.target.value,
            })
          }
        />
        <textarea
          placeholder='Message'
          value={notificationData.message}
          rows={5}
          onChange={(e) =>
            setNotificationData({
              ...notificationData,
              message: e.target.value,
            })
          }
        ></textarea>

        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button
              onClick={() => {
                setShowNotification(false)
                setSelectedNotification(null)
              }}
            >
              Cancel
            </button>
            <button className='proceed' onClick={changeRole}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default CreateNotification
